import React, { useEffect } from 'react';

export default function VideoPlayerModal({ isOpen, onClose, embedUrl, title }) {
  useEffect(() => {
    if (!isOpen) return;
    const handleEsc = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleEsc);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', handleEsc);
      document.body.style.overflow = 'auto';
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) onClose();
  };

  return (
    <div style={s.backdrop} onClick={handleBackdropClick}>
      <div style={s.modal}>
        <div style={s.header}>
          <div style={s.title}>{title || 'Video Lesson'}</div>
          <button style={s.closeBtn} onClick={onClose} aria-label="Close">×</button>
        </div>
        <div style={s.videoWrapper}>
          {embedUrl ? (
            <iframe
              src={embedUrl}
              style={s.iframe}
              frameBorder="0"
              allow="autoplay; fullscreen; picture-in-picture"
              allowFullScreen
              title={title || 'Video Lesson'}
            />
          ) : (
            <div style={s.noVideo}>No video URL available.</div>
          )}
        </div>
      </div>
    </div>
  );
}

const s = {
  backdrop: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(27, 42, 74, 0.85)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 9999,
    padding: '20px',
  },
  modal: {
    background: '#FFFFFF',
    width: '100%',
    maxWidth: '960px',
    maxHeight: '90vh',
    display: 'flex',
    flexDirection: 'column',
    boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '16px 24px',
    borderBottom: '1.5px solid #E8E6E2',
    background: '#1B2A4A',
  },
  title: {
    fontFamily: 'Playfair Display, serif',
    fontSize: '18px',
    fontWeight: '700',
    color: '#D4A847',
    letterSpacing: '0.5px',
  },
  closeBtn: {
    background: 'none',
    border: 'none',
    color: '#FFFFFF',
    fontSize: '32px',
    fontWeight: '300',
    cursor: 'pointer',
    lineHeight: '1',
    padding: '0 4px',
    fontFamily: 'DM Sans, sans-serif',
  },
  videoWrapper: {
    position: 'relative',
    width: '100%',
    paddingTop: '56.25%',
    background: '#000000',
  },
  iframe: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    border: 'none',
  },
  noVideo: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    color: '#FFFFFF',
    fontFamily: 'DM Sans, sans-serif',
    fontSize: '14px',
  },
};
